import { ApiEndpoints } from "./apiEndpoints";
import { fetchData, setHeaderOptions } from "./apiHelpers";
import {
  CreateMedicationRow,
  MedicationRow,
  UpdateMedicationRow,
} from "./medication.type";

export const getMedication = async (
  medicationId: string
): Promise<MedicationRow> => {
  const slug = ApiEndpoints.medication + `/${medicationId}`;

  const options = await setHeaderOptions({ method: "GET" });

  return fetchData<MedicationRow>(slug, options);
};

export const getMedications = async (
  userId?: string
): Promise<MedicationRow[]> => {
  const slug = ApiEndpoints.medication + (userId ? `/user/${userId}` : "");

  const options = await setHeaderOptions({ method: "GET" });

  return fetchData<MedicationRow[]>(slug, options);
};

export const updateMedication = async (
  medication: UpdateMedicationRow,
  patientUserId?: string
): Promise<MedicationRow> => {
  let slug = ApiEndpoints.medication + "/" + medication.id;

  if (patientUserId) {
    slug += `?patient_user_id=${patientUserId}`;
  }

  const options = await setHeaderOptions({ method: "PUT", body: medication });

  return fetchData<MedicationRow>(slug, options);
};

export const createMedication = async (
  medication: CreateMedicationRow,
  patientUserId?: string
): Promise<MedicationRow> => {
  let slug = ApiEndpoints.medication + "/";

  if (patientUserId) {
    slug += `?patient_user_id=${patientUserId}`;
  }

  const options = await setHeaderOptions({ method: "POST", body: medication });

  return fetchData<MedicationRow>(slug, options);
};
